import React, { useEffect, useState, useCallback } from "react";
import { Container, InputGroup, Form } from "react-bootstrap";
import { FiSearch, FiPlus } from "react-icons/fi";
import { getAllTickets } from "../../api/ticketing";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import TicketStatsCards   from "./components/TicketStatsCards/page";
import TicketFilters      from "./components/TicketFilters/page";
import TicketCard         from "./components/TicketCard/page";
import CreateTicketModal  from "./components/CreateTicketModal/page";
import TicketDetailPanel  from "./components/TicketDetailPanel/page";
import ChangeStatusModal  from "./components/ChangeStatusModal/page";
import ReassignModal      from "./components/ReassignModal/page";

const TABS = ["All", "My Tickets", "New", "In Progress"];

const Ticketing = () => {
  const token  = localStorage.getItem("token");
  const roleId = localStorage.getItem("roleId");
const myName = localStorage.getItem("userName");
const myUserId = Number(localStorage.getItem("id"));
  const isEmployee = roleId === "3";

  const [tickets,     setTickets]     = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [searchText,  setSearchText]  = useState("");
  const [activeTab,   setActiveTab]   = useState("All");

  const [filters, setFilters] = useState({
    priority: "All Priority",
    type:     "All Types",
    time:     "Any Time",
    status:   "All Status",
   resource: "All Resource",

  });

  const [showModal,           setShowModal]           = useState(false);
  const [viewMode,            setViewMode]            = useState("list");
  const [editTicket,          setEditTicket]          = useState(null);
  const [detailTicket,        setDetailTicket]        = useState(null);
  const [changeStatusTicket,  setChangeStatusTicket]  = useState(null);
  const [reassignTicket,      setReassignTicket]      = useState(null);
  const refreshDetailRef = React.useRef(null);
  const [sortOrder, setSortOrder] = useState("newest");

  const fetchTickets = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAllTickets(token);
      if (res.status === 200) {
        const list = res.data || [];
        setTickets(list);
        setDetailTicket(prev => {
          if (!prev) return prev;
          const fresh = list.find(t => t.id === prev.id);
          return fresh || prev;
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchTickets(); }, [fetchTickets]);

  const handleOpenCreate = () => { setEditTicket(null); setShowModal(true); };
const handleEdit = (ticket, canEdit = true) => {
    const myUserId = Number(localStorage.getItem("id"));
    const isAdmin  = roleId !== "3";
    console.log("FULL TICKET KEYS:", Object.keys(ticket));
    console.log("FULL TICKET:", JSON.stringify(ticket));
const myName = localStorage.getItem("userName");
    console.log("createdBy:", ticket?.createdBy, "myName:", myName, "match:", ticket?.createdBy === myName);
    const userCanEdit = isAdmin || ticket?.createdBy === myName;    
    setEditTicket({ ...ticket, attachmentOnly: !userCanEdit });
    setDetailTicket(null);
    setShowModal(true);
  };
const baseTickets = isEmployee ? tickets.filter(t => t.assigneeId === myUserId) : tickets;
 const filtered = baseTickets.filter(t => {
    const search = searchText.trim().toLowerCase();
   const matchSearch =
      !search ||
      String(t.title || "").toLowerCase().includes(search) ||
      String(t.ticketNumber || "").toLowerCase().includes(search) ||
      String(t.assignee || "").toLowerCase().includes(search) ||
      String(t.client || "").toLowerCase().includes(search) ||
      String(t.module || "").toLowerCase().includes(search) ||
      String(t.status || "").toLowerCase().includes(search);

    // Closed tickets are hidden from the default listing. They only
    // reappear when the user is actively searching and matches them,
    // OR when a specific resource is selected in the filter (so that
    // resource's closed tickets aren't silently hidden).
    const isClosed = t.status === "Closed";
    const resourceActive = filters.resource && filters.resource !== "All Resource";
    const matchClosed =
      !isClosed ||
      (search.length > 0 && matchSearch) ||
      (resourceActive && t.assignee === filters.resource);

    const matchTab =
      activeTab === "All"         ? true :
activeTab === "My Tickets"  ? t.assigneeId === myUserId :
activeTab === "New"         ? (t.assigneeId === myUserId && t.status === "New") :
activeTab === "In Progress" ? (t.assigneeId === myUserId && t.status === "In Progress") : true;

 const matchPriority = filters.priority === "All Priority" || t.priority   === filters.priority;
    const matchType     = filters.type     === "All Types"    || t.ticketType === filters.type;
    const matchStatus   = filters.status   === "All Status"   || t.status     === filters.status;
    const matchResource = filters.resource === "All Resource" || t.assignee   === filters.resource;
    const now = new Date();
    const created = t.createdAt ? new Date(t.createdAt) : null;
    const daysDiff = created ? (now - created) / (1000 * 60 * 60 * 24) : null;
    const matchTime =
      filters.time === "Any Time"    ? true :
      filters.time === "Last 7 Days" ? (daysDiff !== null && daysDiff <= 7) :
      filters.time === "Last 15 Days"? (daysDiff !== null && daysDiff <= 15) :
      filters.time === "Last 30 Days"? (daysDiff !== null && daysDiff <= 30) : true;

    return matchSearch && matchClosed && matchTab && matchPriority && matchType && matchStatus && matchResource && matchTime;
  }).sort((a, b) => {
    const dateA = new Date(a.createdAt || 0);
    const dateB = new Date(b.createdAt || 0);
    return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
  });

  const tabCount = (tab) => {
const myTickets = tickets.filter(t => t.assigneeId === myUserId); 
  if (tab === "All")         return tickets.length;
    if (tab === "My Tickets")  return myTickets.filter(t => t.status === "New" || t.status === "In Progress").length;
if (tab === "New")         return myTickets.filter(t => t.status === "New").length;
    if (tab === "In Progress") return myTickets.filter(t => t.status === "In Progress").length;
    return 0;
  };

  return (
<Container fluid className="p-4">      {/* Page header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6, flexWrap: "wrap", gap: 12 }}>
        <div>
         <h5 className="page-main-heading">{isEmployee ? "My Tickets" : "Ticketing"}</h5>
<small className="page-sub-heading">{isEmployee ? "Tickets assigned to you." : "Track and resolve client and internal tickets."}</small>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <InputGroup style={{ width: 220 }}>
            <InputGroup.Text style={{ background: "#fff", border: "1px solid #e5e7eb", borderRight: "none" }}>
              <FiSearch color="#9ca3af" size={14} />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search tickets..."
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              style={{ border: "1px solid #e5e7eb", borderLeft: "none", fontSize: 13, height: 36 }}
            />
          </InputGroup>

          {/* ✅ CHANGED: removed !isEmployee guard — button now shows for all roles */}
          <button
            onClick={handleOpenCreate}
            style={{
              background: "#2E5CB8", border: "none", borderRadius: 8,
              color: "#fff", fontWeight: 600, fontSize: 13,
              padding: "8px 16px", display: "flex", alignItems: "center", gap: 6,
              cursor: "pointer", height: 36, whiteSpace: "nowrap",
            }}
          >
            <FiPlus size={14} /> Create Ticket
          </button>
        </div>
      </div>

      {isEmployee ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 14,
            marginBottom: 24,
          }}
        >
         {[
            { key: "assigned",      label: "ASSIGNED",       accent: "#2563eb", count: baseTickets.length },
            { key: "new",           label: "NEW",            accent: "#2563eb", count: baseTickets.filter(t => t.status === "New").length },
            { key: "inProgress",    label: "IN PROGRESS",    accent: "#f97316", count: baseTickets.filter(t => t.status === "In Progress").length },
            { key: "reopen",        label: "REOPEN",         accent: "#a855f7", count: baseTickets.filter(t => t.status === "Reopen").length },
{ key: "highPriority",  label: "HIGH PRIORITY",  accent: "#ef4444", count: baseTickets.filter(t => t.priority === "High" && !["Closed", "Rejected"].includes(t.status)).length },          ].map(({ key, label, accent, count }) => (
            <div
              key={key}
              style={{
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                borderRadius: 10,
                borderLeft: `4px solid ${accent}`,
                padding: "16px 20px",
                display: "flex",
                flexDirection: "column",
                gap: 6,
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              <span style={{ fontSize: 11, fontWeight: 500, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                {label}
              </span>
              <span style={{ fontSize: 28, fontWeight: 700, color: "#111827", lineHeight: 1.1 }}>
{count}              </span>
            </div>
          ))}
        </div>
      ) : (
        <>
          <TicketStatsCards tickets={tickets} />

          <div style={{ display: "flex", gap: 4, marginBottom: 12, borderBottom: "1px solid #e5e7eb", flexWrap: "wrap" }}>
            {TABS.map(tab => {
              const active = activeTab === tab;
              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    padding: "8px 14px", fontSize: 13, fontWeight: active ? 600 : 400,
                    color: active ? "#2E5CB8" : "#6b7280",
                    borderBottom: active ? "2px solid #2E5CB8" : "2px solid transparent",
                    display: "flex", alignItems: "center", gap: 6,
                  }}
                >
                  {tab}
                  <span style={{
                    background: active ? "#dbeafe" : "#f3f4f6",
                    color: active ? "#1d4ed8" : "#6b7280",
                    borderRadius: 10, fontSize: 11, fontWeight: 600,
                    padding: "1px 7px",
                  }}>
                    {tabCount(tab)}
                  </span>
                </button>
              );
            })}
          </div>

         <TicketFilters
  filters={filters}
  onChange={setFilters}
  viewMode={viewMode}
  onViewModeChange={setViewMode}
  totalCount={tickets.length}
  filteredCount={filtered.length}
  tickets={tickets}
/>
        </>
      )}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <span style={{ fontSize: 13, color: "#6b7280" }}>
          Showing <b>{filtered.length}</b> of <b>{baseTickets.length}</b> tickets
        </span>
        <select
          value={sortOrder}
          onChange={e => setSortOrder(e.target.value)}
          style={{
            fontSize: 13, color: "#374151", border: "1px solid #e5e7eb",
            borderRadius: 6, padding: "4px 10px", cursor: "pointer",
            background: "#fff", outline: "none",
          }}
        >
          <option value="newest">Sort: Most recent</option>
          <option value="oldest">Sort: Oldest first</option>
        </select>
      </div>

<div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 8, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#9ca3af" }}>Loading tickets...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#9ca3af" }}>No tickets found</div>
        ) : viewMode === "list" ? (
          <div style={{ padding: "8px" }}>
            {filtered.map(ticket => (
              <TicketCard key={ticket.id} ticket={ticket} onClick={t => setDetailTicket(t)} />
            ))}
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16, padding: "16px" }}>
            {filtered.map(ticket => (
              <TicketCard key={ticket.id} ticket={ticket} onClick={t => setDetailTicket(t)} />
            ))}
          </div>
        )}
      </div>

      <CreateTicketModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSaved={(savedTicket) => { fetchTickets(); if (savedTicket) setDetailTicket(savedTicket); }}
        editTicket={editTicket}
      />

      <TicketDetailPanel
        ticket={detailTicket}
        onClose={() => setDetailTicket(null)}
        onEdit={handleEdit}
        onChangeStatus={(t) => { setChangeStatusTicket(t); }}
        onReassign={(t) => { setReassignTicket(t); }}
        onRefreshNeeded={(fn) => { refreshDetailRef.current = fn; }}
      />

      {changeStatusTicket && (
        <ChangeStatusModal
          ticket={changeStatusTicket}
          onClose={() => setChangeStatusTicket(null)}
          onSaved={() => {
            fetchTickets();
            setChangeStatusTicket(null);
            setTimeout(() => { if (refreshDetailRef.current) refreshDetailRef.current(); }, 300);
          }}
        />
      )}

      {reassignTicket && (
        <ReassignModal
          ticket={reassignTicket}
          onClose={() => setReassignTicket(null)}
          onSaved={() => { fetchTickets(); setReassignTicket(null); }}
        />
      )}

      <ToastContainer />
    </Container>
  );
};

export default Ticketing;